import type { UsersListFetchedPayload } from '@Application/Users/Users/Actions/usersFetched';

// Distinct `type` from `UsersFetchedAction`, and carrying `roleId` alongside `accountId`: this is
// what lets `usersStore` write it into its own `roleImpactedUsers` location, scoped by both, rather
// than the account's whole `users` list that `USERS_FETCHED` owns.
export type RoleImpactedUsersFetchedAction = {
	type: 'ROLE_IMPACTED_USERS_FETCHED';
	payload: UsersListFetchedPayload;
	accountId: number;
	roleId: number;
};

export default (
	payload: UsersListFetchedPayload,
	accountId: number,
	roleId: number,
): RoleImpactedUsersFetchedAction => ({
	type: 'ROLE_IMPACTED_USERS_FETCHED',
	payload,
	accountId,
	roleId,
});
